<template>
    <div>
        <sub-menu-call-center ativo="entrega-resultado" v-if="is_callcenter" />

        <div class="form-row">
            <div class="col col-12" :class="( etiqueta_layouts && etiqueta_layouts.length ) ? 'col-md-6' : 'col-md-8'">
                <az-input 
                    placeholder="Informe o nome ou CPF do paciente..."
                    icon="fas fa-user"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="pacientes.index"
                    optionsDisplay="search"
                    ref="info_paciente"
                    v-model="dados.paciente" 
                    :optimized_ac="true"
                    @input="selecionarPaciente()">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="dados && dados.paciente">
                            <button type="button" class="btn btn-outline-primary" @click="$root.perfil(dados.paciente);">
                                <i class="fa fa-id-badge" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
            <div class="col col-12 col-md-2" v-if="etiqueta_layouts && etiqueta_layouts.length">
                <az-input
                    icon="fa fa-tags"
                    placeholder="Selecione o Layout..."
                    type="select"
                    :optionsList="etiqueta_layouts"
                    optionsData="id_etiqueta_layout"
                    optionsDisplay="search"
                    v-model="layout" />
            </div>
            <div class="col col-12 col-md-2">
                <az-input
                    type="checkbox-group"
                    label="Timbrado"
                    v-model="dados.timbrado"
                    @click="set_timbrado" />
            </div>
            <div class="col col-12 col-md-2">
                <az-input
                    type="checkbox-group"
                    label="Ocultar Gráfico"
                    v-model="dados.block_grafico" />
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state v-if="( !lista || !lista.length ) && ( !lista_pls || !lista_pls.length )" :msg="!dados.paciente ? 'Selecione o Paciente...' : ''" />

        <!-- Lista de agendas -->
        <div class="mt-3" id="lista-de-trabalho">

            <div class="alert alert-danger" v-if="dados && dados.lembrete">
                <i class="fas fa-thumbtack mr-2"></i>
                {{ dados.lembrete }}
            </div>

            <div class="alert alert-danger" v-if="dados && dados.paciente && dados.pagpend && dados.pagpend.length">
                <span class="badge badge-danger">{{ dados.pagpend.length }}</span>
                Pagamento Pendente: {{ dados.pagpend.map(item => ( '#' + item.id_atendimento )).join(', ') }}
            </div>

            <div class="mb-3 mx-3">
                <div v-for="(items, quebra, iqx) in lista_agrupada" :key="'L' + iqx" class="row my-2 py-1 dashcard w3-animate-opacity bg-white">
                    <div class="col col-12">
                        <div class="row align-items-center">
                            <!-- Ação -->
                            <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                                <template v-if="items.length == 1 && items[0].atendimento_procedimento.procedimento.id_especialidade != 2">
                                    <div class="d-flex flex-column" v-if="items[0].status_laudo">
                                        <button class="btn btn-sm" :class="'btn-' + items[0].status_laudo.st_color" :disabled="true">
                                            {{ items[0].status_laudo.search }}
                                        </button>
                                        <span v-if="!( items[0].status_laudo && items[0].status_laudo.fl_pronto ) && items[0].atendimento_procedimento.dt_entrega" class="small text-muted">Prazo: {{ $util.getFormatDate(items[0].atendimento_procedimento.dt_entrega) }}</span>
                                    </div>
                                </template>
                            </div>
                            <!-- Data -->
                            <div class="col col-12 col-md-2"> 
                                <div>{{ $util.getFormatDate(items[0].dt_inclusao) }} {{ items[0].dt_inclusao.substr(11,5) }}
                                    <i class="ml-2" 
                                        :class="( items[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_icon ? items[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + items[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_cor"
                                        data-toggle2="tooltip" data-placement="top" 
                                        :title="items[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.search" 
                                        v-if="items[0] && items[0].atendimento_procedimento && items[0].atendimento_procedimento.atendimento && items[0].atendimento_procedimento.atendimento.marcacao && items[0].atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento"></i>
                                </div>
                                <div>#{{ items[0].atendimento_procedimento.id_atendimento }}
                                    <span v-if="items[0].atendimento_procedimento.atendimento && items[0].atendimento_procedimento.atendimento.marcacao" class="ml-2">

                                        <span v-if="items[0].atendimento_procedimento.atendimento.marcacao.unidade_operacao && items[0].atendimento_procedimento.atendimento.marcacao.unidade_operacao.st_sigla" class="badge badge-light">
                                            {{ items[0].atendimento_procedimento.atendimento.marcacao.unidade_operacao.st_sigla }}
                                        </span>
                                        
                                        <span v-if="items[0].atendimento_procedimento.atendimento.marcacao.st_id_externo" class="small text-muted ml-2">
                                            {{ items[0].atendimento_procedimento.atendimento.marcacao.st_id_externo }}
                                        </span>

                                    </span>
                                </div>
                            </div>
                            
                            <div class="col col-12 col-md-4">
                                <div v-if="items.length > 0 && items[0].atendimento_procedimento.procedimento.id_especialidade == 2 && lista_medicos(items[0]).length > 0">
                                    <az-input 
                                        v-if="!( items && items[0] && items[0].exibir_detalhes )"
                                        label="Solicitante"
                                        :compact="true"
                                        sizing="sm"
                                        placeholder="Profissional Solicitante..."
                                        type="select"
                                        :optionsList="lista_medicos(items[0])"
                                        optionsData="id_medico_solicitante"
                                        :edicao="items[0].atendimento_procedimento.atendimento.solicitante_outros.length > 0"
                                        v-model="items[0].atendimento_procedimento.atendimento.id_medico_solicitante" />
                                </div>
                                <div class="d-flex justify-content-between"> 
                                    <div v-if="items.length == 1 && items[0].atendimento_procedimento.procedimento.id_especialidade != 2">
                                        <celula-dados-procedimento :blockanexos="true" :hor="dados_procedimento(items[0])" />

                                        <div v-if="items[0].contato && items[0].contato.contato_status" class="badge" :class="'badge-' + items[0].contato.contato_status.st_color" :title="items[0].contato.st_observacoes">
                                            {{ items[0].contato.contato_status.search }}
                                        </div>
                                    </div>
                                    <div v-else>
                                        <a href="#" @click.prevent="items[0].exibir_detalhes = !items[0].exibir_detalhes" class="mr-1">
                                            <i class="fa-regular fa-square-plus" v-if="!items[0].exibir_detalhes"></i>
                                            <i class="fa-regular fa-square-minus" v-else></i>
                                        </a>

                                        <a href="#" @click.prevent="imprimir(item)" v-for="(item, iix) in items" :key="iix">
                                            <span class="badge mr-1" :class="'badge-' + ( nao_solicitado(item, items[0].atendimento_procedimento.atendimento.id_medico_solicitante) ? 'light' : ( cor_pilula_item(item) ) )"
                                                data-toggle="tooltip" data-placement="top" :title="item.status_laudo ? item.status_laudo.search : '?'">
                                                {{ sigla(item) }}
                                                <span class="ml-1"
                                                    v-if="item.atendimento_procedimento 
                                                    && item.atendimento_procedimento.amostra_atendimento_procedimento
                                                    && item.atendimento_procedimento.amostra_atendimento_procedimento.amostra
                                                    && item.atendimento_procedimento.amostra_atendimento_procedimento.amostra.st_titulo == 'RECOLETA'">
                                                    <i class="fa-solid fa-registered"></i>
                                                </span>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                                <!-- @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir" /> -->
                            </div>

                            <!-- Impressão -->
                            <div class="col col-12 col-md-4 justify-content-end d-flex">
                                <button type="button" class="btn btn-outline-primary ml-1" title="Amostras" @click="amostras(items[0])" v-if="is_lab(items[0])">
                                    <i class="fa-solid fa-vial"></i>
                                </button>

                                <button type="button" class="btn btn-outline-primary ml-1" :disabled="!layout" @click="imprimir_etiqueta(items[0])">
                                    <i class="fas fa-tag"></i>
                                </button>

                                <template v-if="items.length == 1 && !block_print">
                                    <template v-if="items[0].arquivos && items[0].arquivos.length">
                                        <a :href="arq.arquivo.temporary_url" class="btn ml-1" :class="arq.st_tipo_especial == 'anexo' ? 'btn-outline-secondary' : 'btn-outline-primary'" v-for="(arq, iax) in items[0].arquivos" :key="iax"
                                            target="_blank" title="Imprimir">
                                            <i class="fa fa-paperclip" aria-hidden="true" v-if="arq.st_tipo_especial == 'anexo'"></i>
                                            <i class="fa fa-print" aria-hidden="true" v-else></i>
                                        </a>
                                    </template>

                                    <template v-if="items && items[0] && items[0].atendimento_procedimento && items[0].atendimento_procedimento.st_pacs == 'OK'">
                                        <button type="button" class="btn btn-outline-dark ml-1" 
                                            tile="Abrir visualizador do PACS"
                                            @click="open_url_estudo(items[0].atendimento_procedimento)"
                                            :disabled="$store.state.loading">
                                            <i class="fa-solid fa-x-ray"></i>
                                        </button>
                                    </template>

                                    <template v-if="!(items[0].arquivos && items[0].arquivos.filter(arq => arq.st_tipo_especial != 'anexo').length) && items[0].status_laudo">
                                        <a :href="tratar_link(items[0].link, items[0])" target="_blank" class="btn btn-outline-primary ml-1" v-if="items[0].link" title="Imprimir">
                                            <i class="fa fa-print" aria-hidden="true"></i>
                                        </a>
                                        
                                        <button type="button" class="btn btn-outline-primary ml-1" :disabled="!items[0].status_laudo.fl_pronto" @click="imprimir_lab(items[0])"
                                            title="Imprimir" v-else-if="is_lab(items[0])">
                                            <i class="fa fa-print" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-outline-primary ml-1" :disabled="!items[0].status_laudo.fl_pronto" @click="imprimir(items[0])"
                                            title="Imprimir" v-else>
                                            <i class="fa fa-print" aria-hidden="true"></i>
                                        </button>
                                    </template>
                                </template>
                                <template v-else-if="items.length > 1 && !block_print">
                                    <a :href="tratar_link(get_link(items), items[0])" target="_blank" class="btn btn-outline-primary ml-1" v-if="get_link(items)" title="Imprimir">
                                        <i class="fa fa-print" aria-hidden="true"></i>
                                    </a>

                                    <button type="button" class="btn btn-outline-primary ml-1"  
                                        title="Imprimir"
                                        v-else
                                        :disabled="!tem_laudo_pronto(items)" @click="imprimir_lab(items[0])">
                                        <i class="fa fa-print" aria-hidden="true"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-primary ml-1"  
                                        title="Imprimir"
                                        v-if="tem_laudo_pronto_sem_link(items)"
                                        @click="imprimir_lab(items[0])">
                                        <i class="fa fa-print" aria-hidden="true"></i>
                                    </button>
                                </template>

                                <!-- Entrega de Resultados -->
                                <template v-if="items.length > 0">
                                    <button type="button" class="btn ml-1" :class="( items[0].laudo_entregas && items[0].laudo_entregas.length ) ? 'btn-primary'  : 'btn-outline-primary'"
                                        :disabled="!items.find(item => item.status_laudo && item.status_laudo.fl_pronto)" 
                                        @click="registrar_entrega(items[0])"
                                        title="Registrar Entrega">
                                        <i class="fas fa-hand-holding-medical"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-primary ml-1" 
                                        v-if="item_com_link(items)"
                                        :disabled="!items.find(item => item.status_laudo && item.status_laudo.fl_pronto)" 
                                        @click="enviar_por_email(item_com_link(items))"
                                        title="Enviar por E-mail">
                                        <i class="fa-regular fa-envelope"></i>
                                    </button>
                                </template>

                                <template v-if="items.length > 0 && items[0].atendimento_procedimento.atendimento">

                                   <!-- Menu de opções -->
                                    <div class="dropleft d-flex align-items-center justify-content-center ml-3">
                                        <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <!-- Recibo -->
                                            <template v-if="items.length > 0 && items[0].atendimento_procedimento.atendimento.pagamento_atendimento">
                                                <button type="button" class="dropdown-item"
                                                    @click="ver_recibo(items[0].atendimento_procedimento.atendimento.pagamento_atendimento)"
                                                    title="Pagamento Particular">
                                                    Recibo Particular
                                                </button>
                                            </template>

                                            <!-- Emitir Documento -->
                                            <template v-if="items.length > 0 && items[0].atendimento_procedimento.atendimento.marcacao">
                                                <button type="button" class="dropdown-item"
                                                    @click="novoDocumento(items[0].atendimento_procedimento.atendimento.marcacao)"
                                                    title="Emitir Documento">
                                                    Emitir Documento
                                                </button>

                                                <button type="button" class="dropdown-item"
                                                    @click="ver_tempos(items[0])"
                                                    title="Rastreabilidade do Atendimento">
                                                    Rastreabilidade do Atendimento 
                                                </button>

                                                <button type="button" class="dropdown-item" @click="abrir_contatos(items[0])" title="Ocorrências" v-if="( items.length == 1 ) && !is_lab(items[0])">
                                                    Ocorrências
                                                </button>
                                            </template>
                                        </div>
                                    </div>

                                        
                                </template>
                            </div>
                        </div>

                        <!-- Detalhes -->
                        <template v-if="items && items[0] && items[0].exibir_detalhes">
                            
                            <div class="row mt-3" v-if="items[0].atendimento_procedimento.atendimento.id_medico_solicitante !== null">
                                <div class="col col-12">
                                    <az-input 
                                        label="Solicitante"
                                        :compact="true"
                                        sizing="sm"
                                        placeholder="Profissional Solicitante..."
                                        type="select"
                                        :optionsList="lista_medicos(items[0])"
                                        optionsData="id_medico_solicitante"
                                        v-model="items[0].atendimento_procedimento.atendimento.id_medico_solicitante" />
                                </div>
                            </div>
                            <div class="row" >
                                <div class="col col-12">
                                    <table class="table table-sm mt-3 mb-3">
                                        <thead>
                                            <tr>
                                                <th class="d-none d-md-block">Código</th>
                                                <th>Exame</th>
                                                <th>Status</th>
                                                <th class="d-none d-md-block">Prazo</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(laudo, ilx) in items" :key="ilx" :class="nao_solicitado(laudo, items[0].atendimento_procedimento.atendimento.id_medico_solicitante) ? 'table-secondary text-muted' : ''">
                                                <td class="d-none d-md-block">
                                                    <a href="#" @click.prevent="help_exame(laudo)" v-if="tem_klis">
                                                        <span class="badge" :class="'badge-' + cor_pilula_item(laudo)">
                                                            {{ sigla(laudo) }}
                                                        </span>
                                                    </a>

                                                    <span class="badge" :class="'badge-' + cor_pilula_item(laudo)" v-else>
                                                        {{ sigla(laudo) }}
                                                    </span>
                                                </td>
                                                <td>
                                                    {{ laudo.atendimento_procedimento.procedimento.search }}
                                                </td>
                                                <td>
                                                    <span class="badge" :class="'badge-' + cor_pilula_item(laudo)">
                                                        <span v-if="laudo.emitido && laudo.emitido_info && laudo.emitido_info.titulo">
                                                            {{ laudo.emitido_info.titulo }}
                                                        </span>
                                                        <span v-else-if="laudo.status_info && laudo.status_info.titulo">
                                                            {{ laudo.status_info.titulo }}
                                                        </span>
                                                        <span v-else>
                                                            {{ laudo.status_laudo.search }}
                                                        </span>
                                                    </span>

                                                    <span v-if="laudo.etapa_klis" class="badge badge-light ml-2">
                                                        {{ laudo.etapa_klis }}
                                                    </span>
                                                </td>
                                                <td class="d-none d-md-block">
                                                    <span v-if="laudo.motivo_recoleta" class="text-muted">
                                                        {{ laudo.motivo_recoleta }}
                                                    </span>
                                                    <span v-else-if="!laudo.status_laudo.fl_nao_coletar && laudo.atendimento_procedimento.dt_entrega">
                                                        {{ $util.getFormatDate(laudo.atendimento_procedimento.dt_entrega) }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <pre v-if="false">{{ items }}</pre>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <!-- Legado -->

                <div v-for="(legado, ilx) in lista_pls" :key="'PL' + ilx">
                    <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white">
                        <!-- Ação -->
                        <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                            &nbsp;
                        </div>
                        <!-- Data -->
                        <div class="col col-12 col-md-2"> 
                            <div>{{ $util.getFormatDate(legado.dt_data) }} {{ legado.dt_data.substr(11,5) }}</div>
                            <div>{{ legado.st_id_externo }}</div>
                        </div>
                        
                        <div class="col col-12 col-md-4 d-flex justify-content-between">
                            {{ legado.st_conteudo }}
                        </div>

                        <!-- Impressão -->
                        <div class="col col-12 col-md-4 text-right">
                            <a :href="legado.st_origem" target="_blank" class="btn btn-outline-primary ml-1" v-if="legado.st_origem && legado.st_origem.slice(0,4) == 'http'" title="Imprimir">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Fim Legado -->

                <template v-if="false">
                    <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity bg-white" v-for="(item, index) in lista"
                        :key="index"
                        >
                        <!-- Ação -->
                        <div class="col-12 col-md-2 col-lg-2 text-center my-2 my-md-auto">
                            <div class="d-flex flex-column" v-if="item.status_laudo">
                                <button class="btn btn-sm" :class="'btn-' + item.status_laudo.st_color" :disabled="true">
                                    {{ item.status_laudo.search }}
                                </button>
                            </div>
                        </div>
                        <!-- Data -->
                        <div class="col col-12 col-md-2"> 
                            <div>{{ $util.getFormatDate(item.dt_inclusao) }} {{ item.dt_inclusao.substr(11,5) }}</div>
                            <div>#{{ item.atendimento_procedimento.id_atendimento }}</div>
                        </div>
                        
                        <div class="col col-12 col-md-4 d-flex justify-content-between">
                            <celula-dados-procedimento :hor="dados_procedimento(item)" />
                            <!-- @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir" /> -->
                        </div>

                        <!-- Impressão -->
                        <div class="col col-12 col-md-4 text-right">
                            <button type="button" class="btn btn-outline-primary mr-1" :disabled="!layout" @click="imprimir_etiqueta(item)">
                                <i class="fas fa-tag"></i>
                            </button>
                            <template v-if="item.status_laudo">
                                <button type="button" class="btn btn-outline-primary" :disabled="!item.status_laudo.fl_pronto" @click="imprimir(item)">
                                    <i class="fa fa-print" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary ml-1" v-if="is_lab(item)" 
                                    :disabled="item.status_laudo && !item.status_laudo.fl_pronto" @click="imprimir_lab(item)">
                                    <i class="fas fa-layer-group"></i>
                                </button>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <!-- 
        <div class="modal fade" id="entregaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="entrega">
                    <div class="modal-header">
                        <h5 class="modal-title">Registrar Entrega</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info mb-3">
                            <celula-dados-procedimento :blockanexos="true" :hor="dados_procedimento(entrega)" />
                            <div>{{ $util.getFormatDate(entrega.dt_inclusao) }} {{ entrega.dt_inclusao.substr(11,5) }}</div>
                            <div>#{{ entrega.atendimento_procedimento.id_atendimento }}</div>
                        </div>

                        <az-input
                            label="Entregar para"
                            placeholder="Nome..."
                            required
                            :validate="validate"
                            v-model="entregar_para" />

                        <template v-if="entrega.laudo_entregas && entrega.laudo_entregas.length">
                            <div class="alert alert-secondary mt-3 mb-1">Entregas Realizadas</div>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(entrega_feita, iex) in entrega.laudo_entregas" :key="iex">
                                    <div>{{ entrega_feita.st_nome_recebedor }}</div>
                                    <div class="small" v-if="entrega_feita.created_at">
                                        em {{ $util.getFormatDate(entrega_feita.created_at) }} 
                                        {{ entrega_feita.created_at.substr(11,5) }}
                                        por {{ entrega_feita.usuario.st_login }}</div>
                                    <div class="small text-muted">{{ entrega_feita.st_local }}</div>
                                </li>
                            </ul>
                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="entregar()">Registrar Entrega</az-submit>
                    </div>
                </div>
            </div>
        </div>
    -   -->

        <registrar-entrega 
            ref="entrega" 
            :paciente="dados ? dados.paciente : null" 
            :timbrado="dados ? dados.timbrado : false"
            :block_grafico="dados ? dados.block_grafico : false"
            @refresh="load(true)" />

        <pre class="alert alert-info mt-3" v-if="false">{{ dados }}</pre>
        <pre v-if="false">{{ etiqueta_layouts }}</pre>

        <!-- Documentos -->
        <documento ref="documento" :recepcao="true" />

        <!-- Amostras -->
        <amostras ref="amostras" :viewonly="true" />

        <!-- Modal Recibo -->
        <div class="modal fade" id="reciboModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Recibo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="show_recibo">
                            <recibo-particular-2 ref="recibo" :view="true" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="imprimir_recibo()">Imprimir</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Enviar por E-mail -->
        <div class="modal fade" id="enviarPorEmailModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Enviar por Email</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="dados && dados.paciente && info_mail">
                        <div class="alert alert-info">
                            <div class="lead">{{ dados.paciente.st_nome }}</div>
                            <div>#{{ info_mail.atendimento_procedimento.id_atendimento }}</div>
                        </div>

                        <div class="form-row"> 
                            <div class="col col-12">
                                <az-input
                                    type="email"
                                    label="Email"
                                    placeholder="Informar"
                                    required
                                    :validate="validate"
                                    v-model="info_mail.email" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="confirmar_enviar_por_email()">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Help de Exames -->
        <help-exame-klis ref="help" />

        <!-- Tempos de Marcação -->
        <tempos-marcacao ref="tempos" />

        <!-- Registrar Contatos -->
        <registrar-contatos 
            titulo="Ocorrência / Laudo"
            :lista_status="lista_status ? lista_status.filter(item => item.id_contato_status != 'R') : []" 
            :entrega="true"
            ref="regcontatos" 
            @refresh="load()"></registrar-contatos>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import AzSubmit from '../../util/AzSubmit.vue';
import RegistrarEntrega from './RegistrarEntrega.vue';
import SubMenuCallCenter from '../callcenter/SubMenuCallCenter.vue';
import ReciboParticular2 from './ReciboParticular2.vue';
import Documento from '../consultorio/Documento.vue';
import Amostras from '../laboratorio/Amostras.vue';
import HelpExameKlis from './HelpExameKlis.vue';
import TemposMarcacao from '../../shared/TemposMarcacao.vue';
import RegistrarContatos from '../../shared/RegistrarContatos.vue';

export default {
    data() { 
        return { 
            dados: { 
                paciente: "",
                laudos: [],
                pls: [], 
                timbrado: false, 
            },
            canceltoken: null, 
            etiqueta_layouts: [],
            layout: this.$util.getCookie('etiqueta-layout-entrega'), 
            entrega: null, 
            entregar_para: null, 
            validate: false, 
            block_print: false, 
            show_recibo: false, 
            info_mail: "", 
            tem_klis: false, 
            edicao_contato: null, 
            lista_status: null, 
        };
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        CelulaDadosProcedimento, 
        RegistrarEntrega, 
        SubMenuCallCenter, 
        ReciboParticular2, 
        Documento, 
        Amostras, 
        AzSubmit, 
        HelpExameKlis, 
        TemposMarcacao, 
        RegistrarContatos,
    },

    props: ['id_paciente'],

    computed: { 
        is_callcenter: function () { 
            return ( this.$route.path.slice(0,12) == '/call-center' );
        },

        lista: function () { 
            return this.dados.laudos.filter(laudo => !laudo.excluido);
        },

        lista_pls: function () { 
            if ( !this.dados.pls ) { 
                return [];
            }

            return this.dados.pls;
        }, 

        lista_agrupada: function () { 
            return _.groupBy(this.lista, (item) => {
                return this.is_lab(item) 
                    ? 'L' + item.atendimento_procedimento.id_atendimento 
                    : item.atendimento_procedimento.id_atendimento_procedimento;
            });
        },
    },

    methods: { 
        abrir_contatos (laudo) { 
            this.$util.load(this, { 
                service: 'laudos',
                func: 'laudo',
                parms: { 
                    id_laudo: laudo.id_laudo, 
                    contatos: true, 
                    entrega: true, 
                },
                loadTo: res => { 
                    this.edicao_contato = res;
                    this.lista_status = res.lista_status ? res.lista_status : []; 

                    this.edicao_contato.model = { 
                        type: 'laudo',
                        id: laudo.id_laudo,
                    };

                    this.$refs.regcontatos.editar(this.edicao_contato);
                }
            });
        },

        item_com_link (lista) { 
            return _.first(lista, item => item && item.link);
        },

        open_url_estudo(item) {
            this.$util.load(this, {
                service: 'pep',
                func: 'dr_tis_url',
                redir_api: true,
                parms: {
                    id_atendimento_procedimento: item.id_atendimento_procedimento,
                    id_paciente: item.atendimento.id_paciente,
                    toast: true,
                    is_portal: true
                },
                loadTo: (res) => {
                    if(res && res.url) {
                        this.$util.pacs_open_window(res.url);
                    } else { // if(!toast) {
                        if(res && res.msg) {
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: res.msg,
                                life: 3000
                            });
                        } else {
                            let params = 'msg=Estudo não disponível no PACS: #' + item.id_atendimento + ' / ' + item.st_an;
                            params = new URLSearchParams(params).toString();
                            this.$util.pacs_open_window_default(params);
                        }
                    }
                }
            });
        },

        get_link(lista) { 
            let item = lista.find(item => item.link);

            return item ? item.link : null;
        },

        ver_tempos (laudo) { 
            let base = _.cloneDeep(laudo);
            let marcacao = base.atendimento_procedimento.atendimento.marcacao;

            if ( marcacao ) { 
                marcacao.procedimento = base.atendimento_procedimento.procedimento;
                marcacao.medico = base.atendimento_procedimento.atendimento.medico;
                marcacao.timeline = null; 

                let atendimento = _.cloneDeep(base.atendimento_procedimento.atendimento);
                atendimento.marcacao = null;
                marcacao.atendimento = atendimento;
            }
            
            this.$refs.tempos.abrir(marcacao);
        },

        cor_pilula_item(laudo) { 
            if ( laudo.emitido && laudo.emitido_info && laudo.emitido_info.cor ) 
                return laudo.emitido_info.cor;

            if ( laudo.status_info && laudo.status_info.cor ) 
                return laudo.status_info.cor;

            if ( laudo.status_laudo && laudo.status_laudo.st_color ) { 
                return laudo.status_laudo.st_color;
            }

            return 'secondary';
        },

        help_exame(item) { 
            this.$refs.help.abrir_procedimento(item.atendimento_procedimento.id_procedimento);
        },

        confirmar_enviar_por_email () { 
            this.$util.atualizar(this, { 
                service: 'laudos', 
                func: 'laudo_por_email',
                dados: { 
                    email: this.info_mail.email, 
                    id_laudo: this.info_mail.id_laudo, 
                    link: this.info_mail.link,
                }, 
                toast: true, 
                msg: 'Laudo enviado por e-mail. \n' + this.info_mail.email,
                modal: 'enviarPorEmailModal'
            });
        },

        enviar_por_email(item) { 
            this.info_mail = _.cloneDeep(item);
            this.info_mail.email = _.get(this.dados, 'paciente.cadastro.st_email');
            
            this.$forceUpdate();

            $('#enviarPorEmailModal').modal('show');
        },
        
        amostras (item) { 
            this.$refs.amostras.abrir(item.atendimento_procedimento.id_atendimento);
        },

        novoDocumento(marcacao) {
          this.$refs.documento.novoDocumento(marcacao);
        },

        imprimir_recibo () { 
            this.$refs.recibo.imprimirRecibo();
        },

        ver_recibo (pag) { 
            this.show_recibo = true; 

            this.$nextTick(() => { 
                this.$refs.recibo.abrir(pag.id_pagamento_atendimento);
                $('#reciboModal').modal('show');
            });
        },

        set_timbrado () { 
            this.$util.setCookie('ert', this.dados.timbrado ? 'N' : 'S');
        },

        nao_solicitado (laudo, id_medico_solicitante) { 
            if ( !id_medico_solicitante ) { 
                return false;
            }

            return _.get(laudo, 'atendimento_procedimento.js_solics.' + id_medico_solicitante);
        },

        tratar_link (link, laudo, id_ms_selec = null) { 

            if ( laudo 
                && ['terceiroFleury'].includes(_.get(laudo, 'atendimento_procedimento.amostra_atendimento_procedimento.amostra.terceiro.st_classe')) 
            ) { 
                return link;
            }

            if ( !laudo.atendimento_procedimento.atendimento.id_medico_solicitante ) { 
                return link + ( link.indexOf('?') > 0 ? '&' : '?' ) 
                    + 't=' + ( this.dados.timbrado ? 1 : 0 )
                    + '&r=' + encodeURIComponent(this.$store.state.user.st_login)
                    + ( this.dados.block_grafico ? '&blockgrafico=1' : '' );
            }

            let id_ms = this.$store.state.user.st_tipo == 'R' 
                ? this.$store.state.user.id_medico_solicitante 
                : ( id_ms_selec ? id_ms_selec : laudo.atendimento_procedimento.atendimento.id_medico_solicitante );

            let ms = this.lista_medicos(laudo).find(item => item.id_medico_solicitante == id_ms);

            return link + ( link.indexOf('?') > 0 ? '&' : '?' ) 
                + 'ms=' + id_ms
                + '&n=' + ( ms ? ms.st_numero_conselho : '' )
                + '&t=' + ( this.dados.timbrado ? 1 : 0 )
                + '&r=' + encodeURIComponent(this.$store.state.user.st_login)
                + ( this.dados.block_grafico ? '&blockgrafico=1' : '' );
        },

        lista_medicos (item) { 
            if ( item.atendimento_procedimento.atendimento.id_medico_solicitante === null ) { 
                return [];
            }

            let lista = [item.atendimento_procedimento.atendimento.medico_solicitante];

            if ( item.atendimento_procedimento.atendimento.solicitante_outros ) { 
                lista = lista.concat(item.atendimento_procedimento.atendimento.solicitante_outros.map(item => item.medico_solicitante));
            }

            return lista;
        },

        is_lab(item) { 
            return item.atendimento_procedimento.procedimento.id_especialidade == 2
                || item.atendimento_procedimento.procedimento.id_especialidade == 67;
        },

        registrar_entrega(item) { 
            let lista = _.cloneDeep(this.lista_medicos(item));

            if ( this.is_lab(item) && lista && lista.length > 1 ) { 
                lista = lista.map(medico => { 
                    return { 
                        link: this.tratar_link(item.link, item, medico.id_medico_solicitante),
                        selec: true, 
                        id_medico_solicitante: medico.id_medico_solicitante, 
                        search: medico.search, 
                    };
                });
            }

            this.$refs.entrega.registrar_entrega(item, lista);
        },

        sigla(item) { 
            return item.atendimento_procedimento.procedimento.st_sigla 
                ? item.atendimento_procedimento.procedimento.st_sigla 
                : item.atendimento_procedimento.procedimento.st_procedimento;
        },

        tem_laudo_pronto(lista) { 
            return lista.find(item => item && item.status_laudo && item.status_laudo.fl_pronto) ? true : false;
        },

        tem_laudo_pronto_sem_link(lista) { 
            return lista.find(item => item 
                && item.status_laudo 
                && item.status_laudo.fl_pronto 
                && item.link 
                && !['terceiroKlis', 'terceiroMidSmart', 'terceiroFleury'].includes(_.get(item, 'atendimento_procedimento.amostra_atendimento_procedimento.amostra.terceiro.st_classe')) 
            ) ? true : false;
        },

        imprimir_lab(laudo) { 

            this.$util.print_preview(this.tratar_link('imprimir/laudo_lab/' + laudo.atendimento_procedimento.id_atendimento, laudo), true);
        },

        imprimir(laudo) { 
            if ( laudo.status_laudo && !laudo.status_laudo.fl_pronto ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: laudo.atendimento_procedimento.procedimento.search,
                    detail: "Laudo: " + laudo.status_laudo.search,
                    life: 3000
                });
                return;
            }

            if ( laudo.link ) { 

                if ( !this.block_print && ( laudo.link.indexOf('klisapp') > 0 || laudo.link.indexOf('localhost:8001') > 0 ) ) { 

                    window.open(this.tratar_link(laudo.link, laudo) + '&nums=' + laudo.id_atendimento_procedimento, '_blank');

                } else { 

                    this.$toast.add({
                        severity: "info",
                        summary: "Imprimir",
                        detail: "Clique no botão de imprimir.",
                        life: 3000
                    });

                }

                return;

            }

            this.$util.print_preview('imprimir/laudo/' + laudo.id_laudo, true, { papel: this.dados.timbrado ? 'A4-T' : 'A4-NT' }, true);
        },

        imprimir_etiqueta(laudo) { 
            if ( !this.layout ) { 
                return;
            }

            this.$util.print_preview('imprimir/etiqueta/' + laudo.id_laudo + '/' + this.layout, true);

            this.$util.setCookie('etiqueta-layout-entrega', this.layout);
        },

        dados_procedimento(laudo) { 
            return { 
                marcacao: { 
                    procedimento: laudo.atendimento_procedimento.procedimento,
                    medico: laudo.atendimento_procedimento.medico ? laudo.atendimento_procedimento.medico : laudo.atendimento_procedimento.atendimento.medico, 
                    arquivos: laudo.atendimento_procedimento.atendimento.marcacao ? laudo.atendimento_procedimento.atendimento.marcacao.arquivos : [],
                    doc_pre_atends: laudo.atendimento_procedimento.atendimento.marcacao ? laudo.atendimento_procedimento.atendimento.marcacao.doc_pre_atends : [],  
                    unidade_operacao: laudo.atendimento_procedimento.atendimento.marcacao ? laudo.atendimento_procedimento.atendimento.marcacao.unidade_operacao : [], 
                    sinalizador_atendimento: laudo.atendimento_procedimento.atendimento.sinalizador_atendimento ? laudo.atendimento_procedimento.atendimento.sinalizador_atendimento : [],
                }
            };
        },

        selecionarPaciente() { 
            if ( this.dados.paciente ) { 
                this.$router.replace({ name: this.$route.name, params: { id_paciente: this.dados.paciente.id_pessoa }});
            } else { 
                this.$router.replace({ name: this.$route.name });
            }

            this.entregar_para = "";

            this.$nextTick(() => { 
                this.load();
            });
        },

        load(refresh = false) { 

            if ( !refresh ) { 
                this.dados.laudos = [];
                this.dados.pls = [];
                this.dados.pagpend = [];
            }

            if ( !this.dados.paciente )
                return;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.$router.replace({ name: this.$route.name, params: { id_paciente: this.dados.paciente.id_pessoa }});

            this.canceltoken = this.axios.CancelToken.source();

            this.$store.commit("loading", true);
            
            this.$util.load(this, { 
                service: 'laudos',
                func: 'entrega',
                redir_api: true, 
                parms: { 
                    id_paciente: this.dados.paciente.id_pessoa, 
                    callcenter: this.is_callcenter
                },
                canceltoken: this.canceltoken.token,
                loadTo: res => { 
                    this.block_print = res.block_print ? true : false;

                    if ( res.klis && res.klis_print_entrega ) { 
                        this.block_print = true; 
                    }
                    
                    res.laudos.forEach(laudo => {
                        laudo.exibir_detalhes = false; 
                        laudo.primeiros = true; 
                    });

                    this.dados.laudos = res.laudos;
                    this.dados.pls = res.legado; 
                    this.dados.pagpend = res.pagpend; 
                    this.dados.lembrete = res.lembrete; 
                    this.tem_klis = res.tem_kis;
                }
            });

        }
    },

    mounted() { 

        if ( this.is_callcenter ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Call Center", path: "/call-center" },
                { name: "Entrega de Resultado", path: "/call-center/entrega-resultado" }
            ]);
        } else { 
            this.$store.commit("setBreadcrumb", [
                { name: "Recepção", path: "/recepcao" },
                { name: "Entrega de Resultado", path: "/recepcao/entrega-resultado" }
            ]);
        }

        this.$refs['info_paciente'].$refs.input.focus ();

        this.$util.loadItem(this, { 
            service: 'etiqueta_layouts',
            func: 'index',
            parms: { 
                where: { 
                    st_model_type: 'App\\azure\\laudo',
                }
            }
        })
        .then(res => { 
            this.etiqueta_layouts = res;

            if ( res && res.length == 1 ) { 
                this.layout = res[0].id_etiqueta_layout;
            }
        });

        this.$nextTick(() => { 
            console.log('ert', this.$util.getCookie('ert'));

            this.dados.timbrado = ( this.$util.getCookie('ert') == 'S' ? true : false );

            console.log('timbrado', this.dados.timbrado);
        });

    }   
}
</script>